import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { BeneficioSocial } from 'src/app/core/beneficio-social';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { PessoaFisica } from 'src/app/core/pessoa-fisica';
import { BeneficioSocialPessoaFisica } from '../../../core/beneficio-social-pessoa-fisica';
import { BeneficioSocialService } from '../../../services/beneficio-social/beneficio-social';
import { DataUtilService } from '../../../services/commons/data-util.service';

@Component({
  selector: 'atendimento-apoio-aluno',
  templateUrl: './atendimento-apoio-aluno.component.html',
  styleUrls: ['./atendimento-apoio-aluno.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AtendimentoApoioAlunoComponent implements OnInit {

  @Input() pessoaFisica: PessoaFisica;
  @Input() beneficiosSociaisPessoaFisica: BeneficioSocialPessoaFisica[];

  pinValor = Date.now();

  mostrarBotaoCadastrar = true;

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil;
  beneficiosSociais: BeneficioSocial[];

  constructor(private activatedRoute: ActivatedRoute, private dataUtilService: DataUtilService,
              private beneficioSocialService:BeneficioSocialService) { 
    this.carregarPerfil = new CarregarPerfil();            
  }

  ngOnInit() {
      this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

      if (!this.perfilAcesso.insere){
        this.mostrarBotaoCadastrar = false;
      }

      this.beneficioSocialService.getAll().subscribe((beneficiosSociais: BeneficioSocial[]) => {
        this.beneficiosSociais = beneficiosSociais;
      });
  }
  
  addBeneficio() {
      if (!this.beneficiosSociaisPessoaFisica) {
        this.beneficiosSociaisPessoaFisica = [];
      }
      const beneficio = new BeneficioSocialPessoaFisica();
      beneficio.beneficioSocial = new BeneficioSocial();
      beneficio.pessoaFisica = new PessoaFisica();
  
      this.beneficiosSociaisPessoaFisica.push(beneficio);
  }

  calcularValorTotalRenda(): number {
      const valorRendaCtps = this.pessoaFisica.valorRendaCtps ? this.pessoaFisica.valorRendaCtps : 0;
      if (!this.beneficiosSociaisPessoaFisica || this.beneficiosSociaisPessoaFisica.length === 0) {
          return valorRendaCtps;
      }

      let valorBeneficios = this.beneficiosSociaisPessoaFisica.reduce((total, beneficio) => {
          const valor = beneficio.valor || 0;
          return total + valor;
      }, 0);
      return valorRendaCtps + valorBeneficios;
  }

}




  